import { PapiUser } from '@wix/da-papi-types';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { initializeFriendList, searchFriends } from '../../redux/users/actionCreators';
import { friendsStreamId } from '../../redux/users/constants';
import { useNormalizedUserStream } from './useStream';

/**
 * Manages a searchable list of watched users.
 * Note that the search results are local state, so are not shared between
 * components using the hook (so you can have multiple independently searchable
 * components on the page).
 * */
export function useFriendList(searchTerm = '', streamId = friendsStreamId) {
  const { isFetching, isInitialized, items } = useNormalizedUserStream(streamId);
  const dispatch = useDispatch();
  const [searchResults, setSearchResults] = useState<PapiUser[]>([]);

  useEffect(() => {
    if (searchTerm.length >= 3) {
      dispatch(searchFriends(searchTerm, setSearchResults));
    } else {
      setSearchResults([]);
    }
  }, [dispatch, searchTerm]);

  useEffect(() => {
    if (!isInitialized) {
      dispatch(initializeFriendList(streamId));
    }
  }, [dispatch, isInitialized, streamId]);

  if (searchTerm.length >= 3) {
    return {
      users: searchResults,
      streamId: '',
      isLoading: false,
      isInitialized: true,
    };
  }

  return {
    users: items,
    streamId,
    isInitialized,
    isLoading: !isInitialized || isFetching,
  };
}
